function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var _ref2 = /*#__PURE__*/React.createElement("desc", null, "Created with Sketch.");
var _ref3 = /*#__PURE__*/React.createElement("g", {
  id: "Balance-app",
  stroke: "none",
  strokeWidth: 1,
  fill: "none",
  fillRule: "evenodd",
  strokeLinecap: "round",
  strokeLinejoin: "round"
}, /*#__PURE__*/React.createElement("g", {
  id: "Tablet---Energie-gebouw-Energieverbruik",
  transform: "translate(-798.000000, -263.000000)",
  stroke: "#FFFFFF",
  strokeWidth: 1.5
}, /*#__PURE__*/React.createElement("g", {
  id: "Line-chart---wit",
  transform: "translate(799.000000, 264.000000)"
}, /*#__PURE__*/React.createElement("path", {
  d: "M4.45304348,10.5469565 L7.93826087,7.06173913",
  id: "Path"
}), /*#__PURE__*/React.createElement("path", {
  d: "M12.0365217,6.53217391 L15.3547826,8.46782609",
  id: "Path"
}), /*#__PURE__*/React.createElement("path", {
  d: "M19.6604348,8.17043478 L24.6873913,4.22086957",
  id: "Path"
}), /*#__PURE__*/React.createElement("circle", {
  id: "Oval",
  cx: 26.7391304,
  cy: 2.60869565,
  r: 2.60869565
}), /*#__PURE__*/React.createElement("circle", {
  id: "Oval",
  cx: 17.6086957,
  cy: 9.7826087,
  r: 2.60869565
}), /*#__PURE__*/React.createElement("circle", {
  id: "Oval",
  cx: 9.7826087,
  cy: 5.2173913,
  r: 2.60869565
}), /*#__PURE__*/React.createElement("circle", {
  id: "Oval",
  cx: 2.60869565,
  cy: 12.3913043,
  r: 2.60869565
}))));
function SvgLineSelected(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "32px",
    height: "17px",
    viewBox: "0 0 32 17",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "Line chart - wit") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ref2, _ref3);
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLineSelected);
export default __webpack_public_path__ + "static/media/Line_selected.6866581d8ad08064015732c209e54327.svg";
export { ForwardRef as ReactComponent };